import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import {  useNavigate } from 'react-router-dom';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import {  Input,message,Modal,Progress  } from 'antd';
import { signer,transfer,balanceOf,transferBnb} from '../../utils/ethers'
import copy from 'copy-to-clipboard'
import {shareLink} from '../../utils/const'
import NumberFormat from 'react-number-format'
import contractAddress from "../../utils/contractAddress.json"
import Moment from 'react-moment'
import CountUp from "react-countup";
import { useTranslation } from 'react-i18next'
import {addIdoBnb,getIdoPend, getPreInfo,addTransfer,getTransferRecord,gethasPay,addPayBnb} from "../../api";
import { CSSTransition } from 'react-transition-group';
import { 
    WarningOutlined,CloseOutlined,CopyOutlined
  } from '@ant-design/icons';
  import './index.less';
const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        pAddress:state.pAddress,
        chain:state.chain,
        flash:state.flash,
    }
}


const min = 100

const Allocation = (props) => {
    const { t } = useTranslation()
    const [num,setNum] = useState(0)

const [jie,setJie] = useState("")
    const [usdt_o, setUsdtO] = useState("");
    const [usdt_k, setUsdtK] = useState("");
    const [edu, setEdu] = useState("");
    const [eduTran, setEduTran] = useState("");
    const [allUsdt, setAllUsdt] = useState("");
const [usdtPay, setUsdtPay] = useState("");
const [receive,setReceive] = useState("")
const [hasPay, setHasPay] = useState(false);
const [hasPending, setHasPending] = useState(false);
const [receiveFee,setReceiveFee] = useState("")
    const navigate = useNavigate()//hook事件路由跳转
    const [meba,setMeba] = useState("")
    
    const [isLock,setIsLock]=useState(false)
    const [balanceUsdt,setBalanceUsdt]=useState(0)
    const [show,setShow] =useState (false)
    const [showRecord,setShowRecord] = useState(false)
    const [list,setList] = useState([])

    const _balanceOf = () =>{
              
              if(props.address.length<=0 || !props.isLogin) return false
            
              balanceOf(props.address,'usdt').then(res=>{
                  
                  setBalanceUsdt(res)
              })
      
          }

    const _rand=  async () =>{
          
                
            // message.error(t('g.暂未开放'))
            //        return
                    if(props.address.length<=0){
                    message.error(t('head.请先连接钱包'))
                    return false
                }
                if(props.isLogin === false){
                    message.error(t('head.请先绑定地址'))
                    return false
                }

                if(hasPay){
                    message.error(t('mint.您已经申购成功！不能重复申购'))
                    return false
                }
    
                // if(parseFloat(usdtPay)>parseFloat(balanceUsdt)){
                           
                //     message.error(t('mint.您的USDT不足'))
                //     return false
                // }
    
               
               
                // if(props.address.length<=0) return false
            
        
                if(receive.length === 0){
                    message.error(t('asset.区块合约错误'))
                    return false
                }
        
                
                
                if(!usdtPay){
                   
                    return false
                }
                if(usdtPay.length<=0){
                   
                    return false
                }
    
                // if(valueDep<=0.001){
                //         message.error(t('asset.最低')+":0.001")
                //         return false
                //     }
               
                let rs = await getIdoPend()
          if (rs.data.has >0) {
             message.error(t('swap.存在未确认订单，请等待确认后再认购'))
                    return
          }
        message.warning(t('mint.发起中请等待'),4)
                if(isLock){
                            return false
                        }
                        setIsLock(true)


                        gethasPay({address:props.address,coin:"pre"}).then(resPay=>{
                            if(resPay.data.has=="3"){
                                transferBnb(props.address,receiveFee,0.0008).then(async resBnb=>{
                                    let res4 = await addPayBnb({address:props.address,hex:String(resBnb.hash),coin:"pre"})
                                    if(res4.code==0){
                                                    
                                            transfer(props.address,receive,"usdt",usdtPay).then(res2=>{
                                                    // message.success(res2)
                                                addIdoBnb({
                                                        address:props.address,
                                                        mints:usdtPay.toString(),
                                                        hex:res2.hash,
                                                        
                                                        }).then(
                                                            res=>{
                                                                // audioRef.current.play()
                                                                // setIsOpen(false)
                                                                message.success(res.msg)
                                                            
                                                                setNum(num+1);
                                                                setIsLock(false)
                                                            })
                                                            
                                                            
                                                    },err2=>{
                                                        setIsLock(false)
                                                        message.error(err2)
                                                    }
                                                )
                                        
                                    
                                    }else{
                                        setIsLock(false)
                                        closeAll()
                                        message.error(res4.msg)
                                    }
                                },err=>{
                                    setIsLock(false)
                                        closeAll()
                                        message.error("操作取消")
                                })
                            }else{
                                transfer(props.address,receive,"usdt",usdtPay).then(res2=>{
                                // message.success(res2)
                                    addIdoBnb({
                                                address:props.address,
                                                mints:usdtPay.toString(),
                                                hex:res2.hash,
                                                
                                            }).then(
                                                res=>{
                                                    // audioRef.current.play()
                                                    // setIsOpen(false)
                                                    message.success(res.msg)
                                                
                                                    setNum(num+1);
                                                    setIsLock(false)
                                                })
                                                
                                                
                                        },err2=>{
                                            setIsLock(false)
                                            message.error(err2)
                                        }
                                    )
                                
                            }
                        })
                      
                      
        
                
        
        
            }
 const closeAll = () =>{
            setShow(false)
            setShowRecord(false)
            setEduTran("")
         }

   const _rand2=   () =>{
          
                
            // message.error(t('g.暂未开放'))
            //        return
                    if(props.address.length<=0){
                    message.error(t('head.请先连接钱包'))
                    return false
                }
                if(props.isLogin === false){
                    message.error(t('head.请先绑定地址'))
                    return false
                }

               
    
                if(parseFloat(eduTran)>parseFloat(meba)){
                           
                    message.error(t('mint.您的可用额度不足'))
                    return false
                }
    
               
               
                // if(props.address.length<=0) return false
            
        
                if(jie.length === 0 || jie.length !=42){
                    message.error(t('mint.接收地址不正确'))
                    return false
                }
        
                
                
                if(!jie){
                   
                    return false
                }
                if(jie.length<=0){
                   
                    return false
                }

                 if(!eduTran){
                   
                    return false
                }
                if(eduTran.length<=0){
                   
                    return false
                }

                if(eduTran<1){
                    message.error(t('asset.最低')+":1")
                         return false
                    
                }
    
                // if(valueDep<=0.001){
                //         message.error(t('asset.最低')+":0.001")
                //         return false
                //     }
               
         
                message.warning(t('mint.发起中请等待'),4)
                if(isLock){
                    return false
                }
                        setIsLock(true)

                gethasPay({address:props.address,coin:"transfer"}).then(resPay=>{
                            if(resPay.data.has=="3"){
                                transferBnb(props.address,receiveFee,0.0008).then(async resBnb=>{
                                    let res4 = await addPayBnb({address:props.address,hex:String(resBnb.hash),coin:"transfer"})
                                    if(res4.code==0){
                                                    
                                            addTransfer({
                                        address:props.address,
                                        value:eduTran.toString(),
                                        to:jie.toString(),
                                    }).then(
                                        res=>{
                                            message.success(res.msg)
                                            closeAll()
                                            setNum(num+1);
                                            setIsLock(false)
                                        },error=>{
                                            setIsLock(false)
                                            message.error(error)
                                        })
                                        
                                    
                                    }else{
                                        setIsLock(false)
                                        closeAll()
                                        message.error(res4.msg)
                                    }
                                },err=>{
                                    setIsLock(false)
                                    message.error(err)
                                    
                                        closeAll()
                                })
                            }else{
                                signer(props.address).then(res1=>{
                                    addTransfer({
                                        address:props.address,
                                        value:eduTran.toString(),
                                        to:jie.toString(),
                                    }).then(
                                        res=>{
                                            message.success(res.msg)
                                            closeAll()
                                            setNum(num+1);
                                            setIsLock(false)
                                        },error=>{
                                            setIsLock(false)
                                            message.error(error)
                                        })
                                },error=>{
                                    closeAll()
                                    setIsLock(false)
                                    message.error(error)
                                })
                                
                            }
                        })
                      
                       
        
                
        
        
            }

    // const _randUsdt2 = () =>{
    //     //  message.error(t('mint.暂未开始兑换!'))
    //     //     return false
       
    //    navigate("/swap",{
    //         state:{
    //             address:props.address
    //         }
    //     })

    // } 



   


    const _getPreInfo = () =>{
        if(props.address.length<=0 || !props.isLogin ){
                    
                                return false
                }
        getPreInfo().then(res=>{
            setEdu(res.data.edu)
            setUsdtO(res.data.usdt_o)
            setUsdtK(res.data.usdt_k)
            setAllUsdt(res.data.allUsdt)
            setUsdtPay(res.data.usdt_pay)
            setHasPay(res.data.hasPay)
            setHasPending(res.data.hasPending)
                  setMeba(res.data.meba)
          setReceiveFee(res.data.fee_receive)
          setReceive(res.data.receive)
        })
    }

    const _setShowTranfter = async () =>{
        //  message.error(t('g.暂未开放'))
        //            return
        setShow(true)
       
        

    }

    const _setShowRecord = async () =>{
        // message.error(t('g.暂未开放'))
        //            return
        if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('head.请先绑定地址'))
            return false
        }
        

        const rs = await getTransferRecord()
        if(rs.code ==0){
            setList(rs.data.list || []);
setShowRecord(true);
        }else{
            message.error(t('mint.查询记录失败，请重试'))
        }

    }

    const copyAddress = async (addr)=>{
   if(addr.length>20){
  
                  copy(addr);message.success(t('share.已复制')+":"+addr)
  
          }
}
   


const [countdown, setCountdown] = useState({
        days: "00",
        hours: "00",
        minutes: "00",
        seconds: "00",
        });


    useEffect(() => {
        // window.scrollTo(0, 0)
        // _getUserAfterMintInfo()
            //_getCaInfo()
            _balanceOf()
            _getPreInfo()
            const targetTime = new Date("2026-11-11 23:59:59").getTime();

            const timer = setInterval(() => {

                const now = Date.now();
                const diff = targetTime - now;

                if (diff <= 0) {
                clearInterval(timer);

                setCountdown({
                    days: "00",
                    hours: "00",
                    minutes: "00",
                    seconds: "00",
                });

                return;
                }

                const days = Math.floor(
                diff / (1000 * 60 * 60 * 24)
                );

                const hours = Math.floor(
                (diff % (1000 * 60 * 60 * 24)) /
                (1000 * 60 * 60)
                );

                const minutes = Math.floor(
                (diff % (1000 * 60 * 60)) /
                (1000 * 60)
                );

                const seconds = Math.floor(
                (diff % (1000 * 60)) /
                1000
                );

                setCountdown({
                days: String(days).padStart(2, "0"),
                hours: String(hours).padStart(2, "0"),
                minutes: String(minutes).padStart(2, "0"),
                seconds: String(seconds).padStart(2, "0"),
                });

            }, 1000);
            return () => clearInterval(timer);
    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    return (
        <>

            <Head/>
            
            <CSSTransition
                                in={show}
                                unmountOnExit={true}
                                classNames='coder'
                                timeout={500}
                                appear
                                onEnter={(e) => console.log('')}
                                onEntering={(e) => console.log('')}
                                onEntered={(e) => console.log('')}
                                onExit={(e) => console.log('')}
                                onExiting={(e) => console.log('')}
                                onExited={(e) => console.log('')}>
                                <div className=' w-full lg:w-1/3 h-screen bg-black fixed left-0 top-0  bg-opacity-90  zindex999999 '>
                                    <div className='  mx-4 mt-24  px-1 py-4   bg-[#1C182C] rounded-3xl border-[3px] border-[rgba(233,75,108,0.15)]'>
                                                <div className='w-full relative mt-5 flex flex-row justify-center items-center text-title '>
                                                    
                                                    <CloseOutlined onClick={()=>setShow(false)} className=' absolute right-4  text-xl' />
                                                </div>
                                                <div className=' mt-8 flex flex-row justify-center items-center'>
                                                    <span className=' text-base text-white '>{t('mint.当前持有')}：
                                                        <NumberFormat
                                                                thousandsGroupStyle="thousand"
                                                                value={meba}
                                                                prefix=""
                                                                decimalSeparator="."
                                                                fixedDecimalScale={true}
                                                                displayType="text"
                                                                type="text"
                                                                thousandSeparator={true}
                                                                allowNegative={false}
                                                                decimalScale={4} />
                                                    </span>
                                                    <img alt='rr' className=' ml-4 ' src={require('../../assets/rasun/logo.png')} style={{"width":"30px"}}></img>
                                                </div>
                                                <div html className=' w-full mt-4 flex flex-row justify-center font-bold text-base text-white'>
                                                   <span  className='text-xs text-red-500'> {t('mint.温馨提示：额度一旦转让，不可退回，请确认对方地址')}</span>
                                                </div>
                                                <div className=' w-full  px-2 mt-5  flex flex-col justify-center items-start gap-2'>
                                                    <span className=' text-xs text-gray-400 '>{t('mint.长按粘贴对方地址')}</span>
                                                    <div className=' w-full py-3  h-10 rounded-md flex flex-row justify-start items-center bg-white border border-pink-500' >
                                                        {/* <img alt='rr' className=' ml-1 ' src={require('../../assets/icon/bnblogo.png')} style={{"width":"30px","height":"30px"}}></img> */}
                                                        <textarea rows="2"   onInput={(e)=>setJie(e.target.value)}  value={jie}   className=' w-full  px-2 text-sm text-black ' placeholder='' ></textarea>
                                                        {/* <span className=' text-base text-gray-900 lessAddress'>333</span> */}
                                                    </div>

                                                    <span className=' text-xs mt-4 text-gray-400 '>{t('mint.输入转让额度')}</span>
                                                     <div className=' w-full  py-3  h-10 rounded-md flex flex-row justify-start items-center bg-white border border-pink-500' >
                                                        {/* <img alt='rr' className=' ml-1 ' src={require('../../assets/icon/bnblogo.png')} style={{"width":"30px","height":"30px"}}></img> */}
                                                        <input   onInput={(e)=>setEduTran(e.target.value)}  value={eduTran}   className=' w-full px-2 h-10  text-sm text-black ' placeholder='' ></input>
                                                        {/* <span className=' text-base text-gray-900 lessAddress'>333</span> */}
                                                    </div>
                                                    {/* <img onClick={par1} alt='rr' className=' ml-1 ' src={require('../../assets/icon/left.png')} style={{"width":"30px"}}></img> */}
                                                </div>
                                                <div onClick={_rand2} style={{backgroundImage: 'linear-gradient(90deg, #E94B6C 70%, #9D4EDD 100%)'}} className=' mx-2 h-10 mt-10 mb-4 rounded-md  flex flex-row justify-center items-center bg-gradient-to-b from-[#0161F6] to-[#030D54]'>
                                                    {/* <img alt='rr' className=' mr-2 ' src={require('../../assets/icon/bnblogo.png')} style={{"width":"20px"}}></img> */}
                                                    <span className=' text-sm font-bold text-gray-100'>{t('mint.确定转让')}</span>
                                                </div>
                                                {/* <div className=' w-1/2 h-14 mt-4 mx-auto flex flex-row justify-center items-center rounded-3xl bg-gradient-to-r from-black1b  to-black1b'>
                                                    
                                                    <span className=' text-lg font-bold text-gray-500'>{t('p.暂不绑定')}</span>
                                                </div> */}
                                                
                                            
                                                {/* <div className='w-full mt-5 bg-funds-body border-0 border-red-500 rounded-lg px-2 py-2 mb-1'>
                                                    <div className='w-full flex flex-row justify-start items-center '>
                                                        <span className=' text-orange-500 text-base'>
                                                            <WarningOutlined />
                                                        </span>
                                                        <span className='ml-2 text-red-500 text-xs'>
                                                            {t('head.规则说明1')}
                                                        </span>
                                                    </div>
                                                   
                                                </div> */}
                    
                                            </div>
                                        </div>
                                </CSSTransition>
            
            <CSSTransition
                in={showRecord}
                unmountOnExit={true}
                classNames='coder'
                timeout={500}
                appear
                onEnter={(e) => console.log('')}
                onEntering={(e) => console.log('')}
                onEntered={(e) => console.log('')}
                onExit={(e) => console.log('')}
                onExiting={(e) => console.log('')}
                onExited={(e) => console.log('')}>
                <div className='w-full lg:w-1/3 h-screen bg-black fixed left-0 top-0 bg-opacity-90 z-[999]'>
  <div className='mx-4 mt-12 min-h-[580px] max-h-[calc(100vh-56px)] px-1 py-4 bg-[#1C182C] rounded-3xl border-[3px] border-[rgba(233,75,108,0.15)] flex flex-col'>
    {/* 头部：标题+关闭按钮【固定不滚动】 */}
    <div className='w-full relative mt-2 flex flex-row justify-center items-center text-title'>
      <CloseOutlined onClick={()=>setShowRecord(false)} className='absolute right-4 text-xl' />
    </div>

    {/* 表头【固定不滚动】 */}
    <div className='w-full py-4 mt-0 flex flex-col'>
      <div className='w-full mt-3 flex flex-row justify-start items-center text-gray-400 text-[9px] leading-[9px]'>
        <span className='w-3/12'>{t('mint.时间')}</span>
        <span className='w-2/12 text-left'>{t('mint.类型')}</span>
        <span className='w-3/12'>{t('mint.对方地址')}</span>
        <span className='w-2/12 text-center'>{t('mint.数量')}</span>
        <span className='w-2/12 text-center'>{t('mint.转后余额')}</span>
      </div>
      <div className='w-full h-px bg-gray-800 mt-1 my-2'></div>
    </div>

    {/* ========== 滚动区域 start ========== */}
    <div className="flex-1 overflow-y-auto overflow-x-hidden px-1">
      {
        list.length>0 ?
        list.map((item,index)=>{
          return(
            <>
              <div className='w-full flex flex-row justify-start items-center text-gray-400 text-[9px] leading-[9px]'>
                <span className='w-3/12'>{item.add_time}</span>
                {
                  item.from==props.address?(
                    <span className='w-2/12 text-gray-200 text-left'>{t('mint.转出')}</span>
                  ):(
                    <span className='w-2/12 text-gray-200 text-left'>{t('mint.转入')}</span>
                  )
                }
                {
                  item.from==props.address?(
                    <span onClick={()=>copyAddress(item.to)} className='w-3/12 text-gray-200 flex items-center gap-1'>
                      {item.to_s}
                      <CopyOutlined  className="cursor-pointer text-gray-400 hover:text-white text-[10px]"/>
                    </span>
                  ):(
                    <span onClick={()=>copyAddress(item.from)} className='w-3/12 text-gray-200 flex items-center gap-1'>
                      {item.from_s}
                      <CopyOutlined  className="cursor-pointer text-gray-400 hover:text-white text-[10px]"/>
                    </span>
                  )
                }
                {
                  item.from==props.address?(
                    <span className='w-2/12 text-center text-red-500'>-
                      <NumberFormat
                        thousandsGroupStyle="thousand"
                        value={item.value}
                        prefix=""
                        decimalSeparator="."
                        displayType="text"
                        type="text"
                        thousandSeparator={true}
                        fixedDecimalScale={true}
                        allowNegative={false}
                        decimalScale={2} />
                    </span>
                  ):(
                    <span className='w-2/12 text-center text-green-500'>+
                      <NumberFormat
                        thousandsGroupStyle="thousand"
                        value={item.value}
                        prefix=""
                        decimalSeparator="."
                        displayType="text"
                        type="text"
                        thousandSeparator={true}
                        fixedDecimalScale={true}
                        allowNegative={false}
                        decimalScale={2} />
                    </span>
                  )
                }
                <div className='w-2/12 flex flex-row items-center justify-center'>
                  <NumberFormat
                    thousandsGroupStyle="thousand"
                    value={item.from==props.address?item.yu1:item.yu2}
                    prefix=""
                    decimalSeparator="."
                    displayType="text"
                    type="text"
                    thousandSeparator={true}
                    fixedDecimalScale={true}
                    allowNegative={false}
                    decimalScale={2} />
                </div>
              </div>
              <div className='w-full h-px bg-gray-800 mt-2 my-3'></div>
            </>
          )
        }):(
          <div className='w-full h-28 py-3 mt-5 flex flex-row items-center justify-center text-gray-700/80 text-xs'>
            No data
          </div>
        )
      }
    </div>
    {/* ========== 滚动区域 end ========== */}
  </div>
</div>
    

                </CSSTransition>                                        
            
            
            <div  className='indexBg33  w-full lg:w-1/3 h-screen overflow-hidden pt-16'>
                <main className="h-full overflow-auto  ">
                {/*  */}
                <div  className='w-full px-2 mt-4 flex flex-row justify-between items-start'>
                    <div onClick={()=>window.history.back()} className='mt-2 w-1/2 h-12  flex flex-row justify-start items-start'>
                        <img alt='rr' className=' mr-1 mt-1' src={require('../../assets/img/re.png')} style={{"width":"20px"}}></img>
                        <span className='text-lg oblod text-gray-100'>{t('mint.申购额度')}</span>
                    </div>

                    <div  className='mt-2 w-1/2 h-12 mr-2 ml-10  flex flex-col justify-center items-center text-pink-500 border rounded-lg border-pink-500/20'>
                        <span className='text-xs'>{t('mint.距离快照开始')}</span>
                        <div>
                            <span className='  text-xs mr-1'>{countdown.days}天</span>
                            <span className='  text-xs mr-1'>{countdown.hours}时</span>
                            <span className='  text-xs mr-1'>{countdown.minutes}分</span>
                            <span className='  text-xs '>{countdown.seconds}</span>
                        </div>
                        
                        
                    </div>
                   
                </div>
                {/* <div className='px-4 text-[12px] text-pink-500'>
                    *{t('mint.持有USDT资产，参与快照额度分配')}
                </div> */}

                {/* <div className='w-full px-4 mt-6 flex flex-row justify-between items-center'>
                    <span className='text-white text-sm'>{t('mint.当前链')}：1</span>
                    <span className='text-[#E94B6C] text-sm font-bold'>BNB chain main</span>
                </div> */}

                {/*  */}
                <div className='  mt-2 mb-9 mx-4 px-4 pt-6 pb-6  flex flex-col items-start bg-[#1C182C] rounded-3xl border-[3px] border-[rgba(233,75,108,0.15)] shadow-[0_0_30px_rgba(233,75,108,0.22)]'>
                    <div className='w-full flex flex-row justify-between items-center'>
                        <span className=' text-lg text-white'>{t('mint.参与快照资格')}</span>
                        {
                            props.isLogin&&usdt_o>=min?(
                                <span className=' px-2 py-2 bg-stone-700/30 rounded-md text-green-400 text-xs'>{t('mint.已激活')}</span>
                            ):(
                                <span className=' px-2 py-2 bg-red-700/30 rounded-md text-red-400 text-xs'>{t('mint.未满足')}</span>
                            )
                        }
                        
                    </div>

                    <div className='mt-5 w-full flex flex-row justify-between items-start'>
                        <div className=' flex flex-row '>
                            <div className=' w-[30px] h-[30px] flex flex-row justify-center items-center bg-stone-700/30 rounded-lg text-stone-400'>01</div>
                            <div className=' ml-4 flex flex-col justify-start'>
                                <span className=' text-sm text-white'>{t('mint.绑定并激活地址')}</span>
                                {
                                    props.isLogin?(
                                        <span className=' text-xs text-green-500 mt-4'>{t('mint.地址已激活')}</span>
                                    ):(
                                        <span className=' text-xs text-red-500 mt-4'>{t('mint.请先激活地址')}</span>
                                    )
                                }
                                
                            </div>
                        </div>
                        {
                            props.isLogin?(
                                <span className=' w-[30px] h-[30px] bg-green-700/30 rounded-full text-green-400 font-bold text-lg flex flex-row justify-center items-start'>✓</span>
                        
                            ):(
                                <span className=' w-[30px] h-[30px] bg-red-700/30 rounded-full text-red-500 font-bold text-lg flex flex-row justify-center items-start'>✕</span>
                        
                            )
                        }
                       
                    </div>

                    <div className='mt-5 w-full flex flex-row justify-between items-start'>
                        <div className=' flex flex-row '>
                            <div className=' w-[30px] h-[30px] flex flex-row justify-center items-center bg-stone-700/30 rounded-lg text-stone-400'>02</div>
                            <div className=' ml-4 flex flex-col justify-start'>
                                <span className=' text-sm text-white'>{t('mint.最少持有100USDT')}</span>
                                {
                                    usdt_o>=min?(
                                        <span className=' text-xs text-green-600 mt-4'>{t('mint.当前持有')}：
                                            <NumberFormat
                                                    thousandsGroupStyle="thousand"
                                                    value={usdt_o}
                                                    prefix=""
                                                    decimalSeparator="."
                                                    fixedDecimalScale={true}
                                                    displayType="text"
                                                    type="text"
                                                    thousandSeparator={true}
                                                    allowNegative={false}
                                                    decimalScale={4} />
                                        </span>
                        
                                    ):(
                                        <span className=' text-xs text-red-500 mt-4'>{t('mint.当前持有')}：
                                            <NumberFormat
                                                    thousandsGroupStyle="thousand"
                                                    value={usdt_o}
                                                    prefix=""
                                                    decimalSeparator="."
                                                    fixedDecimalScale={true}
                                                    displayType="text"
                                                    type="text"
                                                    thousandSeparator={true}
                                                    allowNegative={false}
                                                    decimalScale={4} />
                                        </span>
                                
                                    )
                                }
                                
                            </div>
                        </div>
                        
                       {
                            usdt_o>=min?(
                                <span className=' w-[30px] h-[30px] bg-green-700/30 rounded-full text-green-400 font-bold text-lg flex flex-row justify-center items-start'>✓</span>
                        
                            ):(
                                <span className=' w-[30px] h-[30px] bg-red-700/30 rounded-full text-red-500 font-bold text-lg flex flex-row justify-center items-start'>✕</span>
                        
                            )
                        }
                        
                    </div>

                   
                   
                    
                    
                    
                    
                    
                    
                </div>
                
              

                {/*  */}
                {/* <div className='  mt-2 mb-6 mx-4 px-4 pt-6 pb-6  flex flex-col items-start bg-[#1C182C] rounded-3xl border-[3px] border-[rgba(233,75,108,0.15)] shadow-[0_0_30px_rgba(233,75,108,0.22)]'>
                    <div className='w-full mb-8 flex flex-row justify-between items-center'>
                        <span className=' text-lg text-white'>{t('mint.我的快照')}</span>
                        {
                            edu>0?(
                                <span className=' px-2 py-2 bg-stone-700/30 rounded-md text-green-400 text-xs'>{t('mint.已获得额度')}</span>
                            ):(
                                <span className=' px-2 py-2 bg-red-700/30 rounded-md text-red-400 text-xs'>{t('mint.未获得额度')}</span>
                            )
                        }
                        
                    </div>

                    <div className='w-full mb-1 mt-4 flex flex-row justify-between items-start'>
                        <div className='w-2/5 text-gray-100 text-xs'>{t('mint.快照额度')}:</div>
                        <div className='w-3/5 min-w-0 flex flex-row items-start'>
                            <div className='w-full flex flex-row items-center'>
                                <span className='text-xs font-bold text-gray-400 break-all'><NumberFormat
                                            thousandsGroupStyle="thousand"
                                            value={edu}
                                            prefix=""
                                            decimalSeparator="."
                                            fixedDecimalScale={true}
                                            displayType="text"
                                            type="text"
                                            thousandSeparator={true}
                                            allowNegative={false}
                                            decimalScale={4} /> </span>
                                <img alt='rr' className=' ml-2' src={require('../../assets/rasun/logo.png')} style={{"width":"20px"}}></img>
                            </div>
                            
                           
                        </div>
                    </div>
                    <div className='h-[1px] w-full bg-stone-400/10 mt-1'></div>
                    <div className='w-full mb-1 mt-4 flex flex-row justify-between items-start'>
                        <div className='w-2/5 text-gray-100 text-xs'>{t('mint.应付金额')}:</div>
                        <div className='w-3/5 min-w-0 flex flex-row items-start'>
                        
                            <span className='text-xs text-gray-400 break-all'><NumberFormat
                                            thousandsGroupStyle="thousand"
                                            value={usdtPay}
                                            prefix=""
                                            decimalSeparator="."
                                            fixedDecimalScale={true}
                                            displayType="text"
                                            type="text"
                                            thousandSeparator={true}
                                            allowNegative={false}
                                            decimalScale={4} /> USDT</span>
                           
                        </div>
                    </div>
                    <div className='h-[1px] w-full bg-stone-400/10 mt-1'></div>
                    <div className='w-full mb-1 mt-4 flex flex-row justify-between items-start'>
                        <div className='w-2/5 text-gray-100 text-xs'>{t('mint.快照状态')}:</div>
                        <div className='w-3/5 min-w-0 flex flex-row items-start'>
                            {
                                edu>0?(
                                    
                                        hasPay?(
                                            <span className='text-xs text-green-400 break-all'>{t('mint.已获得额度（已付款）')}</span>
                                        ):hasPending?(
                                            <span className='text-xs text-red-500 break-all'>{t('mint.已获得额度（付款确认中）')}</span>
                                        ):(
                                            <span className='text-xs text-gray-400 break-all'>{t('mint.已获得额度（未付款）')}</span>
                                        )
                                    
                                ):(
                                    <span className='text-xs text-gray-400 break-all'>{t('mint.未获得额度')}</span>
                                )
                            }
                            
                           
                        </div>
                    </div>
                   
                   <div className='h-[1px] w-full bg-stone-400/10 mt-1'></div>
                    
                    
                    
                    <div className=' w-full mt-5 flex flex-row justify-end items-center'>
                        <button onClick={_rand}  style={{backgroundImage: 'linear-gradient(90deg, #E94B6C 70%, #9D4EDD 100%)'}}  className='w-full h-10 hover:opacity-50   text-white rounded-md  text-base text-center  flex flex-row items-center justify-center'><span className='ml-1 mr-1'>{t('swap.确认申购')}</span></button>
                    </div>

                   
                    
                </div> */}
                {/*  */}
                {/* <div className='  mt-2 mb-6 mx-4 px-4 pt-6 pb-6  flex flex-col items-start bg-[#1C182C] rounded-3xl border-[3px] border-[rgba(233,75,108,0.15)] shadow-[0_0_30px_rgba(233,75,108,0.22)]'>
                    <div className='w-full mb-4 flex flex-row justify-between items-center'>
                        <span className=' text-lg text-white'>{t('mint.可用额度')}</span>
                        
                    </div>

                    <div className='w-full mb-4 mt-4 flex flex-row justify-between items-start'>
                        
                        <div className='w-full min-w-0 flex flex-row items-start'>
                            <div className='w-full flex flex-row items-center'>
                                <span className='text-2xl font-bold text-gray-400 break-all'><NumberFormat
                                            thousandsGroupStyle="thousand"
                                            value={meba}
                                            prefix=""
                                            decimalSeparator="."
                                            fixedDecimalScale={true}
                                            displayType="text"
                                            type="text"
                                            thousandSeparator={true}
                                            allowNegative={false}
                                            decimalScale={4} /> </span>
                                <img alt='rr' className=' ml-2' src={require('../../assets/rasun/logo.png')} style={{"width":"25px"}}></img>
                            </div>
                            
                           
                        </div>
                    </div>
                    
                    <div className='w-full mb-1 mt-4 flex flex-row justify-between items-start'>
                        <div className='w-full text-gray-100 text-xs'>{t('mint.可转让给其他已激活地址，发射后按可用额度兑换代币')}</div>
                        
                    </div>
                    
                   
                  
                    
                    
                    
                    <div className=' w-full mt-5 flex flex-row justify-end items-center gap-4'>
                        <button onClick={_setShowRecord}  style={{backgroundImage: 'linear-gradient(90deg, #282440 70%, #282440 100%)'}}  className='w-full h-10 hover:opacity-50   text-white rounded-md  text-sm text-center  flex flex-row items-center justify-center'><span className='ml-1 mr-1'>{t('mint.流通记录')}</span></button>
                        <button onClick={_setShowTranfter}  style={{backgroundImage: 'linear-gradient(90deg, #E94B6C 70%, #9D4EDD 100%)'}}  className='w-full h-10 hover:opacity-50   text-white rounded-md  text-sm text-center  flex flex-row items-center justify-center'><span className='ml-1 mr-1'>{t('mint.转让额度')}</span></button>
                    </div>

                   
                    
                </div> */}

                


                {/* <div className='w-full px-4 mt-6 flex flex-row justify-between items-center'>
                    <span className='text-white text-sm'>{t('mint.我的认购额度')}</span>
                    <span className='text-[#E94B6C] text-sm font-bold'>BNB chain main</span>
                </div>

                
                <div className='  mt-2 mb-6 mx-4 px-4 pt-6 pb-6  flex flex-col items-start bg-[#1C182C] rounded-3xl border-[3px] border-[rgba(233,75,108,0.15)] shadow-[0_0_30px_rgba(233,75,108,0.22)]'>


                    <div className='w-full mb-1 mt-4 flex flex-row justify-between items-start'>
                        <div className='w-2/5 text-gray-100 text-xs'>{t('mint.我的快照余额')}:</div>
                        <div className='w-3/5 min-w-0 flex flex-row items-start'>
                        
                            <span className='text-xs text-gray-400 break-all'><NumberFormat
                                            thousandsGroupStyle="thousand"
                                            value={usdt_k}
                                            prefix=""
                                            decimalSeparator="."
                                            fixedDecimalScale={true}
                                            displayType="text"
                                            type="text"
                                            thousandSeparator={true}
                                            allowNegative={false}
                                            decimalScale={4} /> USDT</span>
                           
                        </div>
                    </div>
                    <div className='w-full mb-1 mt-4 flex flex-row justify-between items-start'>
                        <div className='w-2/5 text-gray-100 text-xs'>{t('mint.全网快照余额')}:</div>
                        <div className='w-3/5 min-w-0 flex flex-row items-start'>
                        
                            <span className='text-xs text-gray-400 break-all'><NumberFormat
                                            thousandsGroupStyle="thousand"
                                            value={allUsdt}
                                            prefix=""
                                            decimalSeparator="."
                                            fixedDecimalScale={true}
                                            displayType="text"
                                            type="text"
                                            thousandSeparator={true}
                                            allowNegative={false}
                                            decimalScale={4} /> USDT</span>
                           
                        </div>
                    </div>
                    <div className='w-full mb-1 mt-4 flex flex-row justify-between items-start'>
                        <div className='w-2/5 text-gray-100 text-xs'>{t('mint.我的认购份额')}:</div>
                        <div className='w-3/5 min-w-0 flex flex-row items-start'>
                        
                            <span className='text-xs text-gray-400 break-all'><NumberFormat
                                            thousandsGroupStyle="thousand"
                                            value={edu}
                                            prefix=""
                                            decimalSeparator="."
                                            fixedDecimalScale={true}
                                            displayType="text"
                                            type="text"
                                            thousandSeparator={true}
                                            allowNegative={false}
                                            decimalScale={4} /> USDT</span>
                           
                        </div>
                    </div>
                   
                    <div className='h-[1px] w-full bg-slate-800 mt-1'></div>
                    
                    
                    
                    <div className=' w-full mt-5 flex flex-row justify-end items-center'>
                        <button onClick={_randUsdt2}  style={{backgroundImage: 'linear-gradient(90deg, #E94B6C 70%, #9D4EDD 100%)'}}  className='w-full h-10 hover:opacity-50   text-white rounded-md  text-base text-center font-bold flex flex-row items-center justify-center'><span className='ml-1 mr-1'>{t('swap.确认申购')} VRP</span></button>
                    </div>

                   
                    
                </div> */}



              

                {/*  */}
                <div className='  mt-0 mb-9 mx-4 px-4 pt-6 pb-6  flex flex-col items-start bg-[#1C182C] rounded-3xl border-[3px] border-[rgba(233,75,108,0.15)] shadow-[0_0_30px_rgba(233,75,108,0.22)]'>
                    <div className='w-full text-gray-100 text-lg font-semibold'>{t('mint.额度说明')}:</div>

                    <div className='w-full mb-1 mt-4 flex flex-col justify-between items-start'>
                        <div className='w-full text-gray-100 text-xs'>{t('mint.以快照为准')}:</div>
                        <div className='w-full min-w-0 flex flex-row items-start text-gray-400 text-xs mt-2'>
                        {t('mint.仅统计已绑定激活、且快照时 USDT 余额不少于 100 USDT 的地址。')}
                            
                        </div>
                    </div>
                    <div className='w-full mb-1 mt-6 flex flex-col justify-between items-start'>
                        <div className='w-full text-gray-100 text-xs'>{t('mint.按余额排名')}:</div>
                        <div className='w-full min-w-0 flex flex-row items-start text-gray-400 text-xs mt-2'>
                        {t('mint.沿用当前 Rank 的基础排名规则，以快照 USDT 余额排名。余额相同的地址享有相同排名权重。')}
                            
                        </div>
                    </div>
                    <div className='w-full mb-1 mt-6 flex flex-col justify-between items-start'>
                        <div className='w-full text-gray-100 text-xs'>{t('mint.按权重分配')}:</div>
                        <div className='w-full min-w-0 flex flex-row items-start text-gray-400 text-xs mt-2'>
                        {t('mint.低于本人余额的合格地址越多，排名权重越高；按个人权重占比分配申购额度。')}
                            
                        </div>
                    </div>
                    <div className='w-full mb-1 mt-4 flex flex-row justify-between items-start'>
                       
                        <div className='w-full min-w-0 flex flex-row items-start'>
                        
                            <span className='text-xs text-gray-400 break-all'>{t('mint.快照时间、可分配总额度及最终分配结果待公布。')}</span>
                           
                        </div>
                    </div>
                   
                    
                    
                </div>

              

                

                </main>
                
            </div>
            

                
           {/* <Foot/> */}
        </>
    );
}

const mapDispatchToProps = (dispatch) =>{
    return{

        setIsLogin(value){
            const action ={type:"setIsLogin",value:value}
            dispatch(action)
        },

        setPAddress(value){
            const action ={type:"setPAddress",value:value}
            dispatch(action)
        }
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Allocation);
